var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/prop-types, react/sort-comp */

var classNames = require("classnames");
var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var firstNumericalParse = require("../util.js").firstNumericalParse;
var captureScratchpadTouchStart = require("../util.js").captureScratchpadTouchStart;
var knumber = require("kmath").number;
var KhanMath = require("../util/math.js");

var toNumericString = KhanMath.toNumericString;
var getNumericFormat = KhanMath.getNumericFormat;

/* An input box that accepts only numeric strings
 *
 * Calls onChange(value, format) for valid numbers.
 * Reverts to the current value onBlur or on [ENTER],
 *   but maintains the format (i.e. 3/2, 1 1/2, 150%)
 * Accepts empty input and sends it to onChange as null
 *   if no numeric placeholder is set.
 * If given a checkValidity function, will turn
 *   the background/outline red when invalid
 * If useArrowKeys is set to true, up/down arrows will
 *   increment/decrement integers
 * Optionally takes a size ("mini", "small", "normal")
 */
var NumberInput = React.createClass({
    displayName: "NumberInput",

    propTypes: {
        value: React.PropTypes.number,
        format: React.PropTypes.string,
        placeholder: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
        onChange: React.PropTypes.func.isRequired,
        onFormatChange: React.PropTypes.func,
        checkValidity: React.PropTypes.func,
        size: React.PropTypes.string,
        label: React.PropTypes.oneOf(["put your labels outside your inputs!"])
    },

    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            placeholder: null,
            format: null,
            onFormatChange: function onFormatChange() {
                return null;
            },
            checkValidity: function checkValidity() {
                return true;
            },
            useArrowKeys: false
        };
    },

    getInitialState: function getInitialState() {
        return {
            format: this.props.format
        };
    },

    render: function render() {
        var classes = classNames({
            "number-input": true,
            "invalid-input": !this._checkValidity(this.props.value),
            mini: this.props.size === "mini",
            small: this.props.size === "small",
            normal: this.props.size === "normal"
        });
        if (this.props.className != null) {
            classes = classes + " " + this.props.className;
        }

        return React.createElement("input", _extends({}, this.props, {
            className: classes,
            type: "text",
            ref: "input",
            onChange: this._handleChange,
            onFocus: this._handleFocus,
            onBlur: this._handleBlur,
            onKeyPress: this._handleBlur,
            onKeyDown: this._onKeyDown,
            onTouchStart: captureScratchpadTouchStart,
            defaultValue: toNumericString(this.props.value, this.state.format),
            value: undefined
        }));
    },

    componentDidUpdate: function componentDidUpdate(prevProps) {
        if (!knumber.equal(this.getValue(), this.props.value)) {
            this._setValue(this.props.value, this.state.format);
        }
    },

    /* Return the current "value" of this input
     * If empty, it returns the placeholder (if it is a number) or null
     */
    getValue: function getValue() {
        return this.parseInputValue(ReactDOM.findDOMNode(this.refs.input).value);
    },

    /* Return the current string value of this input */
    getStringValue: function getStringValue() {
        return ReactDOM.findDOMNode(this.refs.input).value.toString();
    },

    parseInputValue: function parseInputValue(value) {
        if (value === "") {
            var placeholder = this.props.placeholder;
            return _.isFinite(placeholder) ? +placeholder : null;
        } else {
            var result = firstNumericalParse(value);
            return _.isFinite(result) ? result : this.props.value;
        }
    },

    /* Set text input focus to this input */
    focus: function focus() {
        ReactDOM.findDOMNode(this.refs.input).focus();
        this._handleFocus();
    },

    blur: function blur() {
        ReactDOM.findDOMNode(this.refs.input).blur();
        this._handleBlur();
    },

    setSelectionRange: function setSelectionRange(selectionStart, selectionEnd) {
        ReactDOM.findDOMNode(this).setSelectionRange(selectionStart, selectionEnd);
    },

    getSelectionStart: function getSelectionStart() {
        return ReactDOM.findDOMNode(this).selectionStart;
    },

    getSelectionEnd: function getSelectionEnd() {
        return ReactDOM.findDOMNode(this).selectionEnd;
    },

    _checkValidity: function _checkValidity(value) {
        if (value == null) {
            return true;
        }

        var val = firstNumericalParse(value);
        var checkValidity = this.props.checkValidity;

        return _.isFinite(val) && checkValidity(val);
    },

    _handleChange: function _handleChange(e) {
        var text = e.target.value;
        var value = this.parseInputValue(text);
        var format = getNumericFormat(text);

        this.props.onChange(value);
        if (format) {
            this.props.onFormatChange(value, format);
            this.setState({ format: format });
        }
    },

    _handleFocus: function _handleFocus() {
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    },

    _handleBlur: function _handleBlur(e) {
        // Only continue on blur or "enter"
        if (e && e.type === "keypress" && e.keyCode !== 13) {
            return;
        }

        this._setValue(this.props.value, this.state.format);
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    },

    _onKeyDown: function _onKeyDown(e) {
        if (this.props.onKeyDown) {
            this.props.onKeyDown(e);
        }

        if (!this.props.useArrowKeys || !_.contains(["ArrowUp", "ArrowDown"], e.key)) {
            return;
        }

        var val = this.getValue();
        if (val !== Math.floor(val)) {
            return; // bail if not an integer
        }

        if (e.key === "ArrowUp") {
            val = val + 1;
        } else if (e.key === "ArrowDown") {
            val = val - 1;
        }

        if (this._checkValidity(val)) {
            this.props.onChange(val);
        }
    },

    _setValue: function _setValue(val, format) {
        $(ReactDOM.findDOMNode(this.refs.input)).val(toNumericString(val, format));
    }
});

module.exports = NumberInput;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/number-input.jsx
 ** module id = 199
 ** module chunks = 0 2
 **/